"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSettings = getSettings;
exports.setSettings = setSettings;
var settings = {};
function LoadSettingsError(name) {
  this.name = 'LoadSettingsError';
  this.message = "Missing setting '".concat(name, "'");
}
function ensureSettingExists(config, name) {
  if (!config || !name) {
    throw new Error("Error verifying settings: must provide both a settings object and a setting name.\n    Settings: ".concat(config, " Setting Name:'").concat(name, "'"));
  }
  if (config[name] === undefined) {
    throw new LoadSettingsError(name);
  }
}
function setSettings(newSettings) {
  ensureSettingExists(newSettings, 'siteId');
  ensureSettingExists(newSettings, 'productId');
  ensureSettingExists(newSettings, 'getOptionsApi');
  settings = newSettings;
}
function getSettings() {
  return settings;
}
//# sourceMappingURL=settings.js.map